/*
import { TypeDemande } from '@/features/domaine/types/opco'

export const TypeRecherche = ['demande', 'dossier', 'facture', 'virement', 'task', 'contacts'] as const
export type TypeRecherche = (typeof TypeRecherche)[number]

export type TypeDemandeRecherche = TypeDemande
*/

export type PreferenceGlobale = {
  pageSize?: number
}

export const PREFERENCES_UTILISATEUR_APP = 'app-global' as const
export const PREFERENCES_UTILISATEUR_APP_PAGESIZE = 20 as const
